export default __webpack_public_path__ + "static/media/avatar7.361e0064.png";